module.exports = __webpack_public_path__ + "static/media/campo6.810d224a.jpg";